import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SET_SESSIONID,
  APPLICANT_SIGNIN_USER_SUCCESS,
  ALUMNI_SIGNIN_USER_SUCCESS,
  ADMIN_SIGNIN_USER_SUCCESS,
  STUDENT_SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  UPDATE_REGSTATUS,
  UPDATE_USER_MODE,
  SET_PAGES,
  UNSET_PAGES,
  SET_STUDENT_PAGES,
  UNSET_STUDENT_PAGES,
} from "constants/ActionTypes";

import { getLoggedInUser, isUserAuthenticated } from '../helpers/authUtils';


const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: isUserAuthenticated() ? getLoggedInUser() : null,
  applicantUser: null,
  adminUser: null,
  studentUser: null,
  alumniUser: null,
  schoolId: 1,
  SessionID: '',
  userMode: '',
  pages: '',
  studentPages: []
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case APPLICANT_SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        applicantUser: action.payload
      }
    }
    case UPDATE_REGSTATUS: {
      return {
        ...state,
        applicantUser: { token: state.applicantUser.token, sid: state.applicantUser.sid, ...action.payload }
      }
    }
    case ADMIN_SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        adminUser: action.payload
      }
    }
    case STUDENT_SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        studentUser: action.payload
      }
    }
    case ALUMNI_SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        alumniUser: action.payload
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case UPDATE_USER_MODE: {
      return {
        ...state,
        userMode: action.payload
      }
    }
    case SET_SESSIONID: {
      return {
        ...state,
        ...action.payload
      }
    }
    case SET_PAGES: {
      return {
        ...state,
        pages: action.payload
      }
    }
    case UNSET_PAGES: {
      return {
        ...state,
        pages: []
      }
    }
    case SET_STUDENT_PAGES: {
      return {
        ...state,
        studentPages: action.payload
      }
    }
    case UNSET_STUDENT_PAGES: {
      return {
        ...state,
        studentPages: []
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      if (action.payload === 'Applicant') {
        return {
          ...state,
          applicantUser: null,
          initURL: '/ApplicantSignin',
          loader: false
        }
      } else if (action.payload === 'Admin') {
        return {
          ...state,
          adminUser: null,
          initURL: '/AdminSignin',
          loader: false
        }
      }
       else if (action.payload === 'Student') {
        return {
          ...state,
          studentUser: null,
          initURL: '/StudentSignin',
          loader: false
        }
      }
       else if (action.payload === 'Alumni') {
        return {
          ...state,
          alumniUser: null,
          initURL: '/AlumniSignin',
          loader: false
        }
      }
       else {
        return {
          ...state,
          authUser: null,
          initURL: '/Signin',
          loader: false
        }
      }

    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state;
  }
}
